import type { WeaponCatalogItem } from '@/types/domain';

export const weaponCatalogSeed: WeaponCatalogItem[] = [
  {
    id: 'weapon-1hammer',
    slug: 'one-handed-hammer',
    filename: '1Hammer.png',
    displayName: '1H Hammer',
    roleCategory: 'Tank',
    imagePath: '/assets/weapons/1Hammer.png',
    isActive: true,
  },
  {
    id: 'weapon-astral',
    slug: 'astral',
    filename: 'ASTRAL.png',
    displayName: 'Astral',
    roleCategory: null,
    imagePath: '/assets/weapons/ASTRAL.png',
    isActive: true,
    notes: 'Role assignment needs officer review.',
  },
  {
    id: 'weapon-ballista',
    slug: 'ballista',
    filename: 'Ballista.png',
    displayName: 'Ballista',
    roleCategory: 'Battle Mount',
    imagePath: '/assets/weapons/Ballista.png',
    isActive: true,
  },
  {
    id: 'weapon-bastion',
    slug: 'bastion',
    filename: 'Bastion.png',
    displayName: 'Bastion',
    roleCategory: 'Tank',
    imagePath: '/assets/weapons/Bastion.png',
    isActive: true,
  },
  {
    id: 'weapon-bearpaws',
    slug: 'bear-paws',
    filename: 'bearpaws.png',
    displayName: 'Bear Paws',
    roleCategory: 'DPS',
    imagePath: '/assets/weapons/bearpaws.png',
    isActive: true,
  },
  {
    id: 'weapon-beetle',
    slug: 'beetle',
    filename: 'Beetle.png',
    displayName: 'Beetle',
    roleCategory: 'Battle Mount',
    imagePath: '/assets/weapons/Beetle.png',
    isActive: true,
  },
  {
    id: 'weapon-behemoth',
    slug: 'behemoth',
    filename: 'Behemoth.png',
    displayName: 'Behemoth',
    roleCategory: 'Battle Mount',
    imagePath: '/assets/weapons/Behemoth.png',
    isActive: true,
  },
  {
    id: 'weapon-black-monk',
    slug: 'black-monk-stave',
    filename: 'black monk.webp',
    displayName: 'Black Monk Stave',
    roleCategory: 'DPS',
    imagePath: '/assets/weapons/black monk.webp',
    isActive: false,
    notes: 'Duplicate-quality asset retained for admin review.',
  },
  {
    id: 'weapon-blight',
    slug: 'blight-staff',
    filename: 'Blight.png',
    displayName: 'Blight Staff',
    roleCategory: 'Healer',
    imagePath: '/assets/weapons/Blight.png',
    isActive: true,
  },
  {
    id: 'weapon-bloodletter-png',
    slug: 'bloodletter',
    filename: 'Bloodletter.png',
    displayName: 'Bloodletter',
    roleCategory: 'Culler',
    imagePath: '/assets/weapons/Bloodletter.png',
    isActive: true,
  },
  {
    id: 'weapon-bloodletter-webp',
    slug: 'bloodletter-alt',
    filename: 'bloodletter.webp',
    displayName: 'Bloodletter (Alt)',
    roleCategory: 'Culler',
    imagePath: '/assets/weapons/bloodletter.webp',
    isActive: false,
  },
  {
    id: 'weapon-bracers',
    slug: 'bracers',
    filename: 'Bracers.png',
    displayName: 'Bracers',
    roleCategory: null,
    imagePath: '/assets/weapons/Bracers.png',
    isActive: true,
    notes: 'Needs exact guild classification.',
  },
  {
    id: 'weapon-carving',
    slug: 'carving-sword',
    filename: 'Carving.png',
    displayName: 'Carving Sword',
    roleCategory: 'DPS',
    imagePath: '/assets/weapons/Carving.png',
    isActive: true,
  },
  {
    id: 'weapon-chariot',
    slug: 'chariot',
    filename: 'Chariot.png',
    displayName: 'Chariot',
    roleCategory: 'Battle Mount',
    imagePath: '/assets/weapons/Chariot.png',
    isActive: true,
  },
  {
    id: 'weapon-damnation',
    slug: 'damnation-staff',
    filename: 'Damnation.png',
    displayName: 'Damnation Staff',
    roleCategory: 'Support',
    imagePath: '/assets/weapons/Damnation.png',
    isActive: true,
  },
  {
    id: 'weapon-enigmatic',
    slug: 'enigmatic-staff',
    filename: 'Enigmatic.png',
    displayName: 'Enigmatic Staff',
    roleCategory: 'Support',
    imagePath: '/assets/weapons/Enigmatic.png',
    isActive: true,
  },
  {
    id: 'weapon-exalted',
    slug: 'exalted-staff',
    filename: 'Exalted.png',
    displayName: 'Exalted Staff',
    roleCategory: 'Healer',
    imagePath: '/assets/weapons/Exalted.png',
    isActive: true,
  },
  {
    id: 'weapon-fallen',
    slug: 'fallen-staff',
    filename: 'Fallen.png',
    displayName: 'Fallen Staff',
    roleCategory: 'Healer',
    imagePath: '/assets/weapons/Fallen.png',
    isActive: true,
  },
  {
    id: 'weapon-galatine',
    slug: 'galatine-pair',
    filename: 'Galatine.png',
    displayName: 'Galatine Pair',
    roleCategory: 'DPS',
    imagePath: '/assets/weapons/Galatine.png',
    isActive: true,
  },
  {
    id: 'weapon-great-arcane',
    slug: 'great-arcane-staff',
    filename: 'Great Arcane.png',
    displayName: 'Great Arcane Staff',
    roleCategory: 'Support',
    imagePath: '/assets/weapons/Great Arcane.png',
    isActive: true,
  },
  {
    id: 'weapon-hallowfall',
    slug: 'hallowfall',
    filename: 'HallowFall.jpg',
    displayName: 'Hallowfall',
    roleCategory: 'Healer',
    imagePath: '/assets/weapons/HallowFall.jpg',
    isActive: true,
  },
  {
    id: 'weapon-heavy-mace',
    slug: 'heavy-mace',
    filename: 'Heavy Mace.png',
    displayName: 'Heavy Mace',
    roleCategory: 'Tank',
    imagePath: '/assets/weapons/Heavy Mace.png',
    isActive: true,
  },
  {
    id: 'weapon-hoj',
    slug: 'hammer-of-justice',
    filename: 'HOJ.png',
    displayName: 'Hammer of Justice',
    roleCategory: 'Tank',
    imagePath: '/assets/weapons/HOJ.png',
    isActive: true,
  },
  {
    id: 'weapon-infinity-blade',
    slug: 'infinity-blade',
    filename: 'infinity blade.webp',
    displayName: 'Infinity Blade',
    roleCategory: 'DPS',
    imagePath: '/assets/weapons/infinity blade.webp',
    isActive: false,
  },
  {
    id: 'weapon-lizard',
    slug: 'lizard',
    filename: 'Lizard.png',
    displayName: 'Lizard',
    roleCategory: 'Battle Mount',
    imagePath: '/assets/weapons/Lizard.png',
    isActive: true,
  },
  {
    id: 'weapon-locus',
    slug: 'locus',
    filename: 'Locus.png',
    displayName: 'Locus',
    roleCategory: 'Support',
    imagePath: '/assets/weapons/Locus.png',
    isActive: true,
  },
  {
    id: 'weapon-longbow',
    slug: 'longbow',
    filename: 'longbow.png',
    displayName: 'Longbow',
    roleCategory: 'DPS',
    imagePath: '/assets/weapons/longbow.png',
    isActive: true,
  },
  {
    id: 'weapon-looter',
    slug: 'looter',
    filename: 'Looter.png',
    displayName: 'Looter',
    roleCategory: null,
    imagePath: '/assets/weapons/Looter.png',
    isActive: false,
    notes: 'Kept in catalog for later classification.',
  },
  {
    id: 'weapon-mace',
    slug: 'one-handed-mace',
    filename: 'MACE.png',
    displayName: '1H Mace',
    roleCategory: 'Tank',
    imagePath: '/assets/weapons/MACE.png',
    isActive: true,
  },
  {
    id: 'weapon-oathkeepers',
    slug: 'oathkeepers',
    filename: 'Oathkeepers.png',
    displayName: 'Oathkeepers',
    roleCategory: 'Support',
    imagePath: '/assets/weapons/Oathkeepers.png',
    isActive: true,
  },
  {
    id: 'weapon-perma',
    slug: 'permafrost-prism',
    filename: 'Perma.png',
    displayName: 'Permafrost Prism',
    roleCategory: 'DPS',
    imagePath: '/assets/weapons/Perma.png',
    isActive: true,
  },
  {
    id: 'weapon-pole-hammer',
    slug: 'pole-hammer',
    filename: 'Pole hammer.png',
    displayName: 'Pole Hammer',
    roleCategory: 'Tank',
    imagePath: '/assets/weapons/Pole hammer.png',
    isActive: true,
  },
  {
    id: 'weapon-realm',
    slug: 'realmbreaker',
    filename: 'Realm.png',
    displayName: 'Realmbreaker',
    roleCategory: 'DPS',
    imagePath: '/assets/weapons/Realm.png',
    isActive: true,
  },
  {
    id: 'weapon-redemption',
    slug: 'redemption-staff',
    filename: 'Redemption.png',
    displayName: 'Redemption Staff',
    roleCategory: 'Healer',
    imagePath: '/assets/weapons/Redemption.png',
    isActive: true,
  },
  {
    id: 'weapon-rootbound',
    slug: 'rootbound-staff',
    filename: 'Rootbound.png',
    displayName: 'Rootbound Staff',
    roleCategory: 'Support',
    imagePath: '/assets/weapons/Rootbound.png',
    isActive: true,
  },
  {
    id: 'weapon-rotcaller',
    slug: 'rotcaller',
    filename: 'Rotcaller.png',
    displayName: 'Rotcaller',
    roleCategory: 'Support',
    imagePath: '/assets/weapons/Rotcaller.png',
    isActive: true,
  },
  {
    id: 'weapon-scythe',
    slug: 'infernal-scythe',
    filename: 'SCYTHE.png',
    displayName: 'Infernal Scythe',
    roleCategory: 'DPS',
    imagePath: '/assets/weapons/SCYTHE.png',
    isActive: true,
  },
  {
    id: 'weapon-shadowcaller',
    slug: 'shadowcaller',
    filename: 'Shadowcaller.png',
    displayName: 'Shadowcaller',
    roleCategory: 'Support',
    imagePath: '/assets/weapons/Shadowcaller.png',
    isActive: true,
  },
  {
    id: 'weapon-shapeshifter',
    slug: 'shapeshifter',
    filename: 'SHAPESHIFTER.png',
    displayName: 'Shapeshifter',
    roleCategory: null,
    imagePath: '/assets/weapons/SHAPESHIFTER.png',
    isActive: true,
    notes: 'Requires final guild role assignment.',
  },
  {
    id: 'weapon-snake',
    slug: 'snake',
    filename: 'Snake.png',
    displayName: 'Snake',
    roleCategory: 'Battle Mount',
    imagePath: '/assets/weapons/Snake.png',
    isActive: true,
  },
  {
    id: 'weapon-spiked',
    slug: 'spiked-gauntlets',
    filename: 'Spiked.png',
    displayName: 'Spiked Gauntlets',
    roleCategory: 'DPS',
    imagePath: '/assets/weapons/Spiked.png',
    isActive: true,
  },
  {
    id: 'weapon-staff-of-balance',
    slug: 'staff-of-balance',
    filename: 'staff balance.png',
    displayName: 'Staff of Balance',
    roleCategory: 'Support',
    imagePath: '/assets/weapons/staff balance.png',
    isActive: true,
  },
  {
    id: 'weapon-truebolt',
    slug: 'truebolt-hammer',
    filename: 'Truebolt Hammer.png',
    displayName: 'Truebolt Hammer',
    roleCategory: 'Tank',
    imagePath: '/assets/weapons/Truebolt Hammer.png',
    isActive: true,
  },
  {
    id: 'weapon-ursine',
    slug: 'ursine-maulers',
    filename: 'ursine.webp',
    displayName: 'Ursine Maulers',
    roleCategory: 'DPS',
    imagePath: '/assets/weapons/ursine.webp',
    isActive: false,
  },
];

export const weaponCatalogMap = Object.fromEntries(
  weaponCatalogSeed.map((weapon) => [weapon.id, weapon]),
);

